const servicePills = [
  { icon: "ri-home-heart-line", label: "Casas" },
  { icon: "ri-building-line", label: "Apartamentos" },
  { icon: "ri-briefcase-line", label: "Oficinas" },
  { icon: "ri-door-open-line", label: "Move In/Out" },
];

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4817d723ee25404dc0d8af2ac89cf40d.jpg"
          alt="Hogar limpio y brillante"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/80 via-teal-800/65 to-emerald-900/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-32 flex flex-col items-center text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 text-white text-sm font-medium px-4 py-2 rounded-full mb-8">
          <i className="ri-map-pin-line text-teal-300"></i>
          Jacksonville, FL · Servicio Profesional de Limpieza
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 max-w-4xl">
          Tu espacio limpio,
          <span className="block text-teal-300">tu mente tranquila</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/85 max-w-2xl mb-10 leading-relaxed">
          En <strong className="text-white">Jek Cleaning Service</strong> transformamos tu hogar, apartamento u oficina con limpieza profesional. Semanal, quincenal, mensual o servicio único — tú decides.
        </p>

        {/* Service Pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {servicePills.map((pill) => (
            <div
              key={pill.label}
              className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 text-white text-sm px-4 py-2 rounded-full"
            >
              <i className={`${pill.icon} text-teal-300`}></i>
              {pill.label}
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo("#agendar")}
            className="bg-white hover:bg-gray-100 text-teal-700 font-bold px-8 py-4 rounded-full text-lg transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
          >
            <i className="ri-calendar-check-line"></i>
            Agendar Cita
          </button>
          <button
            onClick={() => scrollTo("#contacto")}
            className="bg-teal-500 hover:bg-teal-400 text-white font-bold px-8 py-4 rounded-full text-lg transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
          >
            <i className="ri-file-list-3-line"></i>
            Solicitar Cotización Gratis
          </button>
          <button
            onClick={() => scrollTo("#servicios")}
            className="bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/40 text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
          >
            <i className="ri-arrow-down-line"></i>
            Ver Servicios
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white/80">
          <div className="flex items-center gap-2 text-sm">
            <i className="ri-shield-check-line text-teal-300 text-lg"></i>
            Personal verificado
          </div>
          <div className="flex items-center gap-2 text-sm">
            <i className="ri-medal-line text-teal-300 text-lg"></i>
            Garantía de satisfacción
          </div>
          <div className="flex items-center gap-2 text-sm">
            <i className="ri-leaf-line text-teal-300 text-lg"></i>
            Productos seguros
          </div>
          <div className="flex items-center gap-2 text-sm">
            <i className="ri-time-line text-teal-300 text-lg"></i>
            Horarios flexibles
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
